import React from 'react'
import { Box, Typography, styled } from '@mui/material'

import { pxToRem, theme } from '@/shared/styles/themes'
import { CTABlock } from '@/slices/blog/mocks/articles'
import { Button } from '@/components/Button/Button'

export interface ArticleCTAProps {
  block: CTABlock
}

export const ArticleCTA: React.FC<ArticleCTAProps> = ({ block }) => {
  const { title, description, buttonText, buttonLink, variant = 'primary' } = block

  return (
    <CTAWrapper $variant={variant}>
      <CTATitle variant="h3">{title}</CTATitle>
      {description && (
        <CTADescription>{description}</CTADescription>
      )}
      <StyledButton href={buttonLink} secondary size="large">
        {buttonText}
      </StyledButton>
    </CTAWrapper>
  )
}

const CTAWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$variant',
})<{ $variant: 'primary' | 'secondary' }>(({ $variant }) => ({
  padding: pxToRem(28),
  borderRadius: pxToRem(16),
  textAlign: 'center',
  margin: `${pxToRem(40)} 0`,
  backgroundColor: $variant === 'primary'
    ? '#F4F8FB'
    : '#FBEFE9',

  [theme.breakpoints.up('md')]: {
    padding: pxToRem(36),
  },

  [theme.breakpoints.up('lg')]: {
    padding: pxToRem(44),
    margin: `${pxToRem(56)} 0`,
  },
}))

const CTATitle = styled(Typography)({
  fontSize: pxToRem(20),
  fontWeight: 700,
  color: theme.palette.primary.main,
  marginBottom: pxToRem(16),

  [theme.breakpoints.up('md')]: {
    fontSize: pxToRem(24),
  },

  [theme.breakpoints.up('lg')]: {
    fontSize: pxToRem(28),
  },
})

const CTADescription = styled(Typography)({
  fontSize: pxToRem(14),
  color: theme.palette.text.secondary,
  lineHeight: 1.7,
  marginBottom: pxToRem(20),
  whiteSpace: 'pre-line',

  [theme.breakpoints.up('md')]: {
    fontSize: pxToRem(16),
    marginBottom: pxToRem(24),
  },
})

const StyledButton = styled(Button)({
  color: theme.palette.primary.main,
  borderRadius: pxToRem(30),
  fontWeight: 500,
  transition: 'all 0.3s ease',

  '&:hover': {
    backgroundColor: '#4A7FA5',
    opacity: 0.9,
    transform: 'translateY(-2px)',
  },
})
